import ClevertapReact from 'src/utils/clever-tap';
import { debounceHandler, entriesDropDown } from '@helpers';
import ETypo from '@pages/DesignSystem/Typo';
import { focus_state_icons } from 'src/assets/icons/focus_state';
import FilterButton from '@pages/DesignSystem/filter';
import ImageComponent from '@sharedComponent/image-component';
import Inputbox from '@pages/DesignSystem/Input-Field';
import { LoadingOutlined } from '@ant-design/icons';
import MultiSelect from '@pages/DesignSystem/Multiselect/MultiSelect';
import React, { useRef, useState } from 'react';

const PayrollPlusNewTableHeader = ({
	payrollTableLoader = false,
	onChangeHandler,
	handlePagination,
	requestParams,
	handlePayrollPlusFilterSelect,
	dropDownValueState,
	setIsAllSelected,
	setDropDownValueState,
	uploadSpreadsheetShow = true,
}) => {
	const [selectedFilters, setSelectedFilters] = useState([]);
	const currentSelectedLabel = useRef('');
	const nFilterData = [
		{
			filterLabel: 'Payroll Channel',
			count: 0,
			filterValue: dropDownValueState?.[0]?.options?.map((data) => {
				return {
					...data,
					filterValue: data?.payrollChannelName,
				};
			}),
		},
		{
			filterLabel: 'Account Type',
			count: 0,
			filterValue: dropDownValueState?.[1]?.options?.map((data) => {
				return {
					...data,
					filterValue: data?.accountTypeName,
				};
			}),
		},
		{
			filterLabel: 'Establishment ID',
			count: 0,
			filterValue: dropDownValueState?.[2]?.options?.map((data) => {
				return {
					...data,
					filterValue: data?.establishmentId,
				};
			}),
		},
		{
			filterLabel: 'Bank Name',
			count: 0,
			filterValue: dropDownValueState?.[3]?.options?.map((data) => {
				return {
					...data,
					filterValue: data?.bankName,
				};
			}),
		},
	];

	const onFilterValueSelected = (data) => {
		handlePayrollPlusFilterSelect(data);
		const result = [...selectedFilters];
		let indexOfSelectedValue = result.indexOf(data.value);
		currentSelectedLabel.current = data.label;
		if (indexOfSelectedValue > -1) {
			result.splice(indexOfSelectedValue, 1);
		} else {
			result.push(data.value);
		}
		setSelectedFilters(result);
	};

	const clearAllFilters = () => {
		setIsAllSelected(false);
		let lDropDownValueState = (dropDownValueState || [])?.map((dropdown) => {
			let tempOption = (dropdown?.options || [])?.map((option) => {
				return {
					...option,
					isSelected: false,
				};
			});
			const isAllSelected = tempOption?.filter((value) => value?.isSelected)?.length === tempOption?.length;
			return {
				...dropdown,
				isAllSelected,
				options: tempOption,
			};
		});
		setDropDownValueState([...lDropDownValueState]);
		setSelectedFilters([]);
		currentSelectedLabel.current = '';
	};
	return (
		<div className="payroll_plus_new_table_header">
			{uploadSpreadsheetShow ? (
				<>
					<div className="payroll-plus-filters">
						<div style={{ width: '40%' }} onClick={() => ClevertapReact.event('Search_PayrollPlusTable')}>
							<Inputbox
								className="payrollPlus-search"
								prefix={
									payrollTableLoader ? (
										<div
											style={{
												width: 25,
												height: 25,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
											}}>
											<LoadingOutlined className="search-icon" />
										</div>
									) : (
										<ImageComponent className="search-icon" src={focus_state_icons.NewSearch} />
									)
								}
								placeholder="Search by Name or Employee ID."
								onChange={(e) => debounceHandler(e.target.value, onChangeHandler)}
							/>
						</div>
						<FilterButton
							{...{
								value: selectedFilters,
								filterData: nFilterData,
								openedFilter: currentSelectedLabel.current,
								selectedFilter: onFilterValueSelected,
								filterClearAll: () => clearAllFilters(),
								onClick: () => ClevertapReact.event('Filters_PayrollPlustable'),
							}}
						/>
					</div>

					<div className="payroll_plus_new_entries">
						<ETypo light b2 color="#484B52">
							Show
						</ETypo>
						<div style={{ width: '50px' }}>
							<MultiSelect
								{...{
									Option: entriesDropDown,
									value: requestParams?.pageSize || 1,
									dropDownValue: 'value',
									searchVisibility: false,
									onChange: (page) => handlePagination(page?.value, 'pageSize'),
								}}
							/>
						</div>
						<ETypo light b2 color="#484B52">
							Entries
						</ETypo>
					</div>
				</>
			) : (
				''
			)}
		</div>
	);
};

export default PayrollPlusNewTableHeader;
